module.exports = __webpack_public_path__ + "static/img/logo.dff6902.png";


//////////////////
// WEBPACK FOOTER
// ./static/footer/logo.png
// module id = 8MPR
// module chunks = 3